<div class="graph" [style.width]="width" [style.height]="height">
  <svg:svg class="graph-container" [attr.viewBox]="_stringifiedViewBox$ | async" #graphContainer>
    <defs class="defs">
      <ng-container
        *ngIf="_defsTemplate"
        [ngTemplateOutlet]="_defsTemplate.template"
      ></ng-container>
    </defs>

    <ng-content></ng-content>

    <svg:g class="nodes-container" #nodesContainer>
      <svg:g
        *ngFor="let node of transformedNodes; trackBy: _trackById"
        class="node"
        [id]="node.id"
        [class.is-visible]="node._isVisible"
        [attr.transform]="node._transform"
        #node
      >
        <ng-container
          [ngTemplateOutlet]="_nodeTemplate.template"
          [ngTemplateOutletContext]="{ $implicit: node }"
        ></ng-container>
      </svg:g>
    </svg:g>

    <svg:g class="edges-container">
      <svg:g
        *ngFor="let edge of transformedEdges; trackBy: _trackById"
        class="edge"
        [id]="edge.id"
        #edge
      >
        <ng-container
          [ngTemplateOutlet]="_edgeTemplate.template"
          [ngTemplateOutletContext]="{ $implicit: edge }"
        ></ng-container>
      </svg:g>
    </svg:g>
  </svg:svg>
</div>
